import { Injectable } from '@angular/core';
import { GoogleMapsService } from '../../services/google-maps.service';
import { CityTransformer } from './city.transformer';
import * as ApiUser from '../../interfaces/api/user';
import { User } from '../../interfaces/user';

@Injectable({
  providedIn: 'root',
})
export class UserTransformer {
  constructor(private googleMapsService: GoogleMapsService, private cityTransformer: CityTransformer) {}

  transform(data: ApiUser.ResponseBody): User {
    return {
      id: data?.id,
      id_reference: data.id_reference,
      mh_customer: data.mh_customer,
      phone: data.phone,
      phone_verified_at: data.phone_verified_at,
      reference_table: data.reference_table,
      role: data.role,
      username: data.username,
      // name: data.name,
      // email: data.email,
      // phone: data.phone,
      // username: data.username,
      // mh_customer: data.mh_customer,
      // birth_day: data.birth_day,

      // birth_date: data.mh_customer.birth_date,
      // gender: data.mh_customer.gender,

      //postcode: data.user.post_code,
      //city: this.cityTransformer.transform(data.mh_city),
      // location: {
      //   latitude: data.user.latitude,
      //   longitude: data.user.longitude,
      //   staticMapUrl: this.googleMapsService.getStaticMapUrl(data.latitude, data.longitude),
      // },
      //point: data.user.poin,
    };
  }
}
